module.exports = __webpack_public_path__ + "static/media/Oliver_Daniel.95d9ca51.jpg";